import { render } from "./JFcirculation.vue?vue&type=template&id=0ed28e62&scoped=true"
import script from "./JFcirculation.vue?vue&type=script&lang=js"
export * from "./JFcirculation.vue?vue&type=script&lang=js"

import "./JFcirculation.vue?vue&type=style&index=0&id=0ed28e62&lang=scss&scoped=true"
import "./JFcirculation.vue?vue&type=style&index=1&id=0ed28e62&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed28e62"]])

export default __exports__